import { useEffect } from 'react';

/**
 * Sitemap route component
 * Redirects to the sitemap generated by Edge Function
 */
export const SitemapRoute = () => {
  useEffect(() => {
    // Redirect to the edge function endpoint
    const sitemapUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-sitemap`;
    window.location.href = sitemapUrl;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Genererar sitemap...</h1>
        <p className="text-muted-foreground">Du omdirigeras till sitemap.xml</p>
      </div>
    </div>
  );
};
